/**
 * SolutionsInstitutions — `/solutions/institutions` route.
 * Body is the hand-built design from `solutions-institutions.html`.
 * Navbar + Footer + App.js routing unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SolutionsInstitutionsHero } from "../components/SolutionsInstitutionsHero";

export default function SolutionsInstitutions() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="solutions-institutions-page">
      <Helmet>
        <title>For Institutions : T-REX Network</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <SolutionsInstitutionsHero />
      <Footer />
    </main>
  );
}
